export default {
  "nav.home": "Accueil",
  "nav.activities": "Activités",
  "nav.courts": "Terrains",
  "nav.pricing": "Tarifs",
  "nav.tournaments": "Tournois",
  "nav.advertisers": "Annonceurs",
  "nav.investors": "Investisseurs",
  "nav.about": "À Propos",
  "nav.contact": "Contact",
  "nav.bookCourt": "Réserver un Court",
  "nav.downloadApp": "Télécharger l'App",
  "footer.slogan": "L'Excellence du Tennis au Cœur de l'Afrique",
  "footer.quickLinks": "Liens Rapides",
  "footer.followUs": "Suivez-nous",
  "footer.mobileApp": "Application Mobile",
  "footer.contact": "Contact",
  "footer.copyright": "© 2026 Tennis Club de Douala. Tous droits réservés.",
  "footer.legal": "Mentions Légales",
  "footer.privacy": "Politique de Confidentialité",
  "lang.switch": "EN",
  "lang.label": "Langue",
  "hero.title": "L'Excellence du Tennis",
  "hero.titleHighlight": "au Cœur de l'Afrique",
  "hero.subtitle": "Tennis Club de Bonanjo — Douala, Cameroun",
  "hero.ctaJoin": "Rejoindre le Club",
  "hero.ctaBook": "Réserver un Court",
  "hero.badge1": "Tournois ITF",
  "hero.badge2": "6 Courts",
  "hero.badge3": "Certifié International",
  "hero.scrollDown": "Découvrir",
  "numbers.courts": "Courts Disponibles",
  "numbers.hours": "Ouvert 7j/7 — 8h à 22h",
  "numbers.members": "Membres Actifs",
  "numbers.itf": "Tournois ITF J30 Organisés",
  "numbers.coaches": "Coachs Certifiés",
  "numbers.camp": "Jeunes au Kid Summer Camp",
  "vision.title": "Notre Vision",
  "vision.subtitle": "Message du Président",
  "vision.quote": "Notre ambition est de faire du tennis club de Douala le lieu de référence du tennis à Douala et au Cameroun. Nous pratiquons le tennis et assurons sa promotion à travers la détection des futurs champions.",
  "vision.point1": "Revalorisation complète du club — infrastructure et positionnement",
  "vision.point2": "Formation de coaches certifiés niveau international",
  "vision.point3": "Construction et rénovation de courts aux normes ITF",
  "vision.point4": "Extension Padel — sport en pleine expansion",
  "vision.point5": "Rayonnement international — tournois et partenariats",
  "vision.cta": "En Savoir Plus",
  "courts.title": "Nos Terrains",
  "courts.subtitle": "Des installations de classe mondiale au cœur de Douala",
  "courts.central": "Court Central",
  "courts.centralDesc": "Court principal — Compétitions et matchs officiels",
  "courts.standard": "Court Standard",
  "courts.training": "Court d'Entraînement",
  "courts.padel": "Bientôt — Terrains de Padel",
  "courts.padelDesc": "Extension prévue — Le sport qui conquiert le monde arrive au TCD",
  "courts.cta": "Réserver un Court",
  "courts.total": "Installations disponibles",
  "pricing.title": "Tarifs & Adhésion",
  "pricing.subtitle": "Des formules adaptées à votre pratique",
  "pricing.monthly": "Mensuel",
  "pricing.yearly": "Annuel",
  "pricing.kids": "Kid Summer Camp",
  "pricing.monthlyPrice": "24 000 FCFA",
  "pricing.yearlyPrice": "288 000 FCFA",
  "pricing.kidsPrice": "35 000 FCFA",
  "pricing.perMonth": "/mois",
  "pricing.perYear": "/an",
  "pricing.bestOffer": "Meilleure offre",
  "pricing.monthlyFeatures": "Accès illimité aux courts · Cours collectifs · Vestiaires · Éclairage nocturne · Réservation prioritaire",
  "pricing.yearlyFeatures": "Tout le mensuel + · 2 mois offerts · Coaching personnalisé · Invités gratuits (2/mois) · Accès événements VIP",
  "pricing.kidsFeatures": "Tennis quotidien · Ateliers IA · Yoga & Pilates · Sports collectifs · Développement personnel",
  "pricing.note": "Téléchargez l'application mobile pour réserver vos courts",
  "pricing.cta": "S'inscrire",
  "app.title": "Réservez votre court en quelques secondes",
  "app.subtitle": "Notre application mobile vous permet de réserver un court, suivre les événements et rester connecté au club où que vous soyez.",
  "app.feature1": "Réservation instantanée",
  "app.feature2": "Calendrier des événements",
  "app.feature3": "Actualités du club",
  "app.feature4": "Notifications en temps réel",
  "app.googlePlay": "Disponible sur Google Play",
  "app.appStore": "Télécharger dans l'App Store",
  "news.title": "Actualités & Événements",
  "news.subtitle": "Les dernières nouvelles du Tennis Club de Douala",
  "news.viewAll": "Voir toutes les actualités",
  "gallery.title": "Galerie",
  "gallery.subtitle": "Le Tennis Club de Douala en images",
  "gallery.all": "Tous",
  "gallery.courts": "Terrains",
  "gallery.tournaments": "Tournois",
  "gallery.coaching": "Coaching",
  "gallery.kids": "Enfants",
  "gallery.events": "Événements",
  "storeModal.title": "Choisissez votre boutique",
  "storeModal.subtitle": "Téléchargez l'application pour réserver votre court en quelques secondes",
  "storeModal.getItOn": "Disponible sur",
  "storeModal.googlePlay": "Google Play",
  "storeModal.downloadOn": "Télécharger sur",
  "storeModal.appStore": "App Store"
}